import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
  } from "react";
  import { Form, Row, Col, Modal, Button } from "react-bootstrap";
  import {
    getCapitulosTomo2,
    getLeyesTomo2,
    getSubcapitulosByCapituloIdAndLey,
    getApartadosBySubcapituloId,
    getSubapartadosByApartadoId,
    getSubapartadosByCapituloId,
    getSubapartadosBySubcapituloId,
    getSubcapitulosByCapituloId,
  } from "../../services/sumarioService";
  import { INFO } from "../../components/iconsSVG/IconsSVG";
  
  const CombosAnidados = forwardRef(({ combosAnidadosT2 }, ref) => {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const [capitulos, setCapitulos] = useState([]);
    const [leyes, setLeyes] = useState([]);
    const [subcapitulos, setSubcapitulos] = useState([]);
    const [apartados, setApartados] = useState([]);
    const [subapartados, setSubapartados] = useState([]);    
  
    const [selectedCapituloId, setSelectedCapituloId] = useState("");
    const [selectedLeyId, setSelectedLeyId] = useState("");
    const [selectedSubcapituloId, setSelectedSubcapituloId] = useState("");
    const [selectedApartadoId, setSelectedApartadoId] = useState("");
    const [selectedSubapartadoId, setSelectedSubapartadoId] = useState("");
  
    useEffect(() => {
      const fetchCapitulos = async () => {
        const capituloList = await getCapitulosTomo2();
        const arrayTransformado = capituloList.map(item => {
          const [id, displayName] = Object.entries(item)[0];
          return { id: parseInt(id, 10), displayName }; // Devuelves el objeto transformado
        });
        setCapitulos(arrayTransformado);
        setSelectedCapituloId("");
        setLeyes([]);
        setSelectedLeyId("");
        setSelectedSubcapituloId("");
        setSelectedApartadoId("");
        setSelectedSubapartadoId("");
        setSubcapitulos([]);
        setApartados([]);
        setSubapartados([]);
      };
      fetchCapitulos();
    }, []);

    useEffect(() => {
      combosAnidadosT2(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId,selectedLeyId);
      if (selectedCapituloId) {
        setLeyes([]);
        setSelectedLeyId("");
        const fetchLeyes = async () => {
          const leyesList = await getLeyesTomo2(selectedCapituloId);

          if(Object.keys(leyesList || {}).length > 0){
            // Transformar el Map (objeto JSON) en un array de objetos [{ id, displayName }]
            const arrayTransformado = Object.entries(leyesList || {}).map(([id, displayName]) => ({
              id: parseInt(id, 10), // Aseguramos que el ID sea un número
              displayName,
            }));
            setLeyes(arrayTransformado);
            setSelectedSubcapituloId("");
            setSelectedApartadoId("");
            setSelectedSubapartadoId("");
            setSubcapitulos([]);
            setApartados([]);
            setSubapartados([]);
        } else {
          const subcapituloList = await getSubcapitulosByCapituloId(
            selectedCapituloId
          );
          const arrayTransformado = Object.entries(subcapituloList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubcapitulos(arrayTransformado);
          setSelectedApartadoId("");
          setSelectedSubapartadoId("");
          setApartados([]);
          setSubapartados([]);
        }
        const subapartadoList = await getSubapartadosByCapituloId(
          selectedCapituloId
        );
        const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
          id: parseInt(id, 10), // Aseguramos que el ID sea un número
          displayName,
        }));
        setSubapartados(arrayTransformado);
        };
        fetchLeyes();
      } else {
        setSelectedLeyId("");
        setSelectedSubcapituloId("");
        setSelectedApartadoId("");
        setSelectedSubapartadoId("");
        setLeyes([]);
        setSubcapitulos([]);
        setApartados([]);
        setSubapartados([]);
      }
      }, [selectedCapituloId]);
  
    useEffect(() => {
      combosAnidadosT2(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId,selectedLeyId);
      if (selectedLeyId) {
        const fetchSubcapitulos = async () => {
          const subcapituloList = await getSubcapitulosByCapituloIdAndLey(
            selectedCapituloId,
            selectedLeyId
          );
          const arrayTransformado = Object.entries(subcapituloList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubcapitulos(arrayTransformado);
          setSelectedApartadoId("");
          setSelectedSubapartadoId("");
          setApartados([]);
          setSubapartados([]);
        };
        fetchSubcapitulos();  
      } else {
        setSelectedApartadoId("");
        setSelectedSubapartadoId("");
        setApartados([]);
        setSubapartados([]);
        const fetchSubApartados = async () => {
          const subapartadoList = await getSubapartadosByCapituloId(
            selectedCapituloId
          );
          const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransformado);
        };
        fetchSubApartados();
        setSelectedSubcapituloId("");
        setSelectedApartadoId("");
        setSelectedSubapartadoId("");
        setSubcapitulos([]);
        setApartados([]);
        setSubapartados([]);
      }
    }, [selectedLeyId]);
  
    useEffect(() => {
      combosAnidadosT2(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId,selectedLeyId);
      if (selectedSubcapituloId) {
        const fetchApartados = async () => {
          const apartadoList = await getApartadosBySubcapituloId(
            selectedSubcapituloId
          );
          const arrayTransformado = Object.entries(apartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setApartados(arrayTransformado);
          setSelectedSubapartadoId("");
          setSubapartados([]);

          const subapartadoList = await getSubapartadosBySubcapituloId(
            selectedSubcapituloId
          );
          const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransform);
        };
        fetchApartados();
      } else {
        setSelectedApartadoId("");
        setSelectedSubapartadoId("");
        setApartados([]);
        setSubapartados([]);
        const fetchSubApartados = async () => {
          const subapartadoList = await getSubapartadosByCapituloId(
            selectedCapituloId
          );
          const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransformado);
        };
        fetchSubApartados();
      }
    }, [selectedSubcapituloId]);
  
    useEffect(() => {
      combosAnidadosT2(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId,selectedLeyId);
      if (selectedApartadoId) {
        const fetchSubapartados = async () => {
          const subapartadoList = await getSubapartadosByApartadoId(
            selectedCapituloId,
            selectedSubcapituloId,
            selectedApartadoId
          );
          const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransformado);
        };
        fetchSubapartados();
      } else {
        if (selectedSubcapituloId) {
          const fetchSubapartados = async () => {
              const subapartadoList = await getSubapartadosBySubcapituloId(
                selectedSubcapituloId
              );
              if(Object.keys(subapartadoList || {}).length > 0){
                const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
                  id: parseInt(id, 10), // Aseguramos que el ID sea un número
                  displayName,
                }));
                setSubapartados(arrayTransformado);
              }else{
                if (selectedCapituloId) {
                  const subapartadoList = await getSubapartadosByCapituloId(
                    selectedCapituloId
                  );
                  const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
                    id: parseInt(id, 10), // Aseguramos que el ID sea un número
                    displayName,
                  }));
                  setSubapartados(arrayTransform);
                }
              }
              
            };
            fetchSubapartados();
        }else if (selectedCapituloId) {
            const fetchSubapartados = async () => {
            const subapartadoList = await getSubapartadosByCapituloId(
              selectedCapituloId
            );
            const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
              id: parseInt(id, 10), // Aseguramos que el ID sea un número
              displayName,
            }));
            setSubapartados(arrayTransform);
          };
          fetchSubapartados();
    
      }
    }}, [selectedApartadoId]);

    useEffect(() => {
      combosAnidadosT2(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId,selectedLeyId);
    }, [selectedSubapartadoId]);

    useImperativeHandle(ref, () => ({
      resetCapituloId: () => setSelectedCapituloId(""), 
      }));
  
    return (
      <>
        <strong>Sumario (tipo de publicación) TOMO 2</strong>    
        <Form className="m-0 mt-2 p-0 ps-3 border rounded">
          <p className="m-0 mb-1 p-0 d-flex">
            {/* {" "} */}
            <Button className="fondo-blanco-icono" onClick={handleShow}>
              {/* <INFO color_icono="#203C77" color_fondo="white" class="p-0 m-0"/> */}
            </Button>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>Búsqueda a partir de Capítulo, Ley, Subcapítulo, Apartado, Subapartado.</Modal.Body>
            </Modal>
          </p>
          <Row className="mb-2">
            <Col md={4}>
              <Form.Group controlId="formCapitulos">
                <Form.Label style={{ fontSize: '.85em' }}>Capítulo</Form.Label>
                <Form.Select
                  className="mb-2"  
                  // as="select"
                  value={selectedCapituloId}
                  onChange={(e) => setSelectedCapituloId(e.target.value)}
                >
                  {/* <option value="">Seleccione un capítulo</option> */}
                  <option value="">-</option>
                  {capitulos.map((capitulo) => (
                    <option key={capitulo.id} value={capitulo.id}>
                      {capitulo.displayName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4} className={leyes.length > 0 ? "" : "d-none"}>
              <Form.Group controlId="formLeyes">
                <Form.Label style={{ fontSize: '.85em' }}>Ley</Form.Label>
                <Form.Select
                  // as="select"
                  value={selectedLeyId}
                  onChange={(e) => setSelectedLeyId(e.target.value)}
                  disabled={!leyes}
                >
                  {/* <option value="">Seleccione una ley</option> */}
                  <option value="">-</option>
                  {leyes.map((leyes) => (
                    <option key={leyes.id} value={leyes.id}>
                      {leyes.displayName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
    
          <Row className="mb-2">
            <Col md={4} className={subcapitulos.length > 0 ? "" : "d-none"}>
              <Form.Group controlId="formSubcapitulos">
                <Form.Label style={{ fontSize: '.85em' }}>Subcapítulo</Form.Label>
                <Form.Select
                  // as="select"
                  value={selectedSubcapituloId}
                  onChange={(e) => setSelectedSubcapituloId(e.target.value)}
                  disabled={!subcapitulos}
                >
                  {/* <option value="">Seleccione un subcapitulo</option> */}
                  <option value="">-</option>
                  {subcapitulos.map((subcapitulo) => (
                    <option key={subcapitulo.id} value={subcapitulo.id}>
                      {subcapitulo.displayName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4} className={apartados.length > 0 ? "" : "d-none"}>
              <Form.Group controlId="formApartados">
                <Form.Label style={{ fontSize: '.85em' }}>Apartado</Form.Label>
                <Form.Select
                  className="mb-2"
                  // as="select"
                  value={selectedApartadoId}
                  onChange={(e) => setSelectedApartadoId(e.target.value)}
                  disabled={!apartados}
                >
                  {/* <option value="">Seleccione un apartado</option> */}
                  <option value="">-</option>
                  {apartados.map((apartado) => (
                    <option key={apartado.id} value={apartado.id}>
                      {apartado.displayName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={4} className={subapartados.length > 0 ? "" : "d-none"}>
              <Form.Group controlId="formSubapartados">
                <Form.Label style={{ fontSize: '.85em' }}>Subapartado</Form.Label>
                <Form.Select
                  // as="select"
                  value={selectedSubapartadoId}
                  onChange={(e) => setSelectedSubapartadoId(e.target.value)}
                  disabled={!subapartados}
                >
                  {/* <option value="">Seleccione un subapartado</option> */}
                  <option value="">-</option>
                  {subapartados.map((subapartado) => (
                    <option key={subapartado.id} value={subapartado.id}>
                      {subapartado.displayName}
                    </option>
                  ))}
                </Form.Select>                
              </Form.Group>
            </Col>
          </Row>
          <br />
        </Form>
      </>
    );
  });
  
  export default CombosAnidados;
  